import { c as _c } from "react/compiler-runtime";
import { AboutSection } from "@/enums";
export default function Footer() {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = function printLink(href, text, t1) {
      const newTab = t1 === undefined ? false : t1;
      const target = newTab ? "_blank" : "_self";
      return <a href={href} target={target} rel={newTab ? "noopener noreferrer" : undefined}>{text}</a>;
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const printLink = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = function printLinkWithImage(href_0, img, text_0, t2) {
      const newTab_0 = t2 === undefined ? true : t2;
      const target_0 = newTab_0 ? "_blank" : "_self";
      return <a href={href_0} target={target_0} rel={newTab_0 ? "noopener noreferrer" : undefined}><img width="0" height="0" style={{
          height: "18px",
          width: "auto"
        }} src={img} alt={text_0} />{" "}{text_0}</a>;
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const printLinkWithImage = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = function printSeparator() {
      return <span>|</span>;
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const printSeparator = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="d-flex align-items-center justify-content-center flex-wrap gap-2">{printLinkWithImage("https://x.com/punk6529", "/twitter.png", "@punk6529")}{printSeparator()}{printLinkWithImage("https://x.com/6529Collections", "/twitter.png", "@6529Collections")}{printSeparator()}{printLinkWithImage("https://discord.gg/join-om", "/discord.png", "OM Discord")}{printSeparator()}{printLinkWithImage("https://github.com/6529-Collections", "/github_w.png", "6529-Collections")}</span>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <footer className="d-flex flex-column align-items-center justify-content-center gap-2" id="footer">{t3}<span className="d-flex align-items-center justify-content-center flex-wrap gap-2">{printLink(`/about/${AboutSection.TERMS_OF_SERVICE}`, "Terms of Service")}{printSeparator()}{printLink(`/about/${AboutSection.PRIVACY_POLICY}`, "Privacy Policy")}{printSeparator()}{printLink(`/about/${AboutSection.COPYRIGHT}`, "Copyright")}{printSeparator()}{printLink(`/about/${AboutSection.COOKIE_POLICY}`, "Cookie Policy")}{printSeparator()}{printLink(`/about/${AboutSection.LICENSE}`, "License")}{printSeparator()}{printLink("/tools/api", "API")}{printSeparator()}{printLink(`/about/${AboutSection.CONTACT_US}`, "Contact Us")}{printSeparator()}{printLink("https://status.6529.io/", "Status", true)}</span></footer>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}